export default {
  sublevelIntermediateTable: {
    title: "",
    component: () =>
      import(
        /* webpackChunkName: "archive_detail" */ "@/mods/archive/migrationArchiveData/detailView/SublevelIntermediateTable"
      ),
  },
};
